'use client';
import React, { FunctionComponent, ReactNode } from 'react';
import FullScreenWrapper from '../../common/FullScreenWrapper';
import MobileFilterController from './MobileFilterController';
import { Box, Button, Typography } from '@mui/material';
import { useResponsive } from '../../../contexts/ResponsiveContext';
import { useLocale } from '../../../contexts/LocaleProvider';
import { ProductsContent } from '../../../graphql/pimcore/modules/siteContent/types/ProductsContent';
import { formatCountIcuString } from '../../../utils/formatCount';

interface MobileFilterSectionProps {
    isFilterControllerOpen: boolean;
    toggleFilterController: () => void;
    partCounts: number;
    children: ReactNode;
    handleApplyFilters: () => void;
    isApplyFiltersEnabled: boolean;
    contentTree: ProductsContent;
}

const MobileFilterSection: FunctionComponent<MobileFilterSectionProps> = ({
    isFilterControllerOpen,
    toggleFilterController,
    partCounts,
    children,
    handleApplyFilters,
    isApplyFiltersEnabled,
    contentTree,
}) => {
    const { responsiveWidth } = useResponsive();
    const { locale } = useLocale();

    return (
        <>
            {isFilterControllerOpen && (
                <FullScreenWrapper isOpen={isFilterControllerOpen}>
                    <MobileFilterController
                        isFilterControllerOpen={isFilterControllerOpen}
                        toggleFilterController={toggleFilterController}
                        partCounts={partCounts}
                        contentTree={contentTree}
                    />
                    <Box sx={{ paddingBottom: '9rem' }}>{children}</Box>
                    <Box
                        sx={{
                            position: 'fixed',
                            bottom: 0,
                            left: 0,
                            width: '100%',
                            backgroundColor: '#F2F2F2',
                            display: 'flex',
                            flexDirection: 'column',
                            padding: '0',
                            gap: '0.5rem',
                            paddingTop: '1rem',
                            paddingBottom: '1rem',
                            alignItems: 'center', // 子元素置中
                        }}
                        data-testid="mobile-apply-zone"
                    >
                        <Typography
                            variant="h6"
                            sx={{
                                textAlign: 'center',
                                fontWeight: 400,
                                fontSize: '16px',
                                fontFamily: 'Poppins',
                            }}
                            data-testid="partcount_zone"
                        >
                            {formatCountIcuString(
                                contentTree.filters.labels.resultCountCompact.content,
                                partCounts,
                                locale
                            )}
                        </Typography>
                        <Button
                            disabled={!isApplyFiltersEnabled}
                            variant="text"
                            onClick={handleApplyFilters}
                            sx={{
                                backgroundColor: isApplyFiltersEnabled ? '#B75332' : '#D3D3D3',
                                transition: 'none',
                                color: '#FFFFFF',
                                '&:hover': {
                                    background: 'linear-gradient(0deg, #B75332 0%, #EE9769 100%)',
                                },
                                width: responsiveWidth,
                                borderRadius: '10px',
                            }}
                        >
                            {contentTree.filters.buttonLabels.applyFilters.content}
                        </Button>
                    </Box>
                </FullScreenWrapper>
            )}
            {!isFilterControllerOpen && (
                <MobileFilterController
                    isFilterControllerOpen={isFilterControllerOpen}
                    toggleFilterController={toggleFilterController}
                    partCounts={partCounts}
                    contentTree={contentTree}
                />
            )}
        </>
    );
};

export default MobileFilterSection;
